import router from '@/router'

import enLocale from 'element-ui/lib/locale/lang/en'

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'

import viLocale from 'element-ui/lib/locale/lang/vi'

const global = {
  enLocale: enLocale,

  zhLocale: zhLocale,

  zhTWLocale: zhTWLocale,

  viLocale: viLocale,

  // 订单信息
  orderInfo: {},

  // 判断是否外链
  isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
  },

  currency: {
    fixed: 0,
    create_time: 0,
    currency_from: '',
    currency_to: '',
    modify_time: 0,
    rate: '',
    symbol: '',
    status: 0
  },

  setCurrency(obj) {
    global.currency = obj
  },

  setLanguage(lang) {
    window.localStorage.setItem('lang', lang)
    global.lang = lang
  },

  lang: window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : '',

  config: {
    langList: [
      {
        code: '',
        create_time: 0,
        icon: '',
        id: 1,
        modify_time: 0,
        name: '',
        remark: '',
        status: 1
      }
    ],
    webLogo: {
      logo: '',
      logo2: ''
    },
    system: {
      Lang: '',
      RegMode: '',
      Version: '',
      WebTitle: '',
      currency: '',
      kefuUrl: '',
      kefuWeiXin: '',
      kefu_qq: '',
      single_amount: ''
    }
  },

  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}, // 用户信息

  ApiList: [],

  MenuList: [],

  // 设置用户信息
  setUserInfo(obj) {
    window.localStorage.setItem('userInfo', JSON.stringify(obj))
    global.userInfo = obj
  },

  loadedLanguages: [],

  token: localStorage.getItem('adminToken'),

  // 设置token
  setToken(token) {
    window.localStorage.setItem('adminToken', token)
    global.token = token
  },

  allSliceFlag: false, // 是否静音

  autoPlayFlag: false, // 是否自动播放过一次

  toastShow: false,
  toastMsg: '',

  ent_id: null, // 企业ID

  // 退出登录
  logout() {
    localStorage.removeItem('adminToken')
    global.userInfo = {}
    global.token = null
    router.push({ name: 'login' })
  }
}

export default global
